import { Button, makeStyles } from "@material-ui/core"
import { useTranslation } from "react-i18next"
import DeleteIcon from "@material-ui/icons/Delete";

export interface IUserActions {
    hasPermission: boolean;
    handleEditUser: (e: React.MouseEvent<HTMLElement>) => void;
    onDeleteUser: (e: React.MouseEvent<HTMLElement>) => void;
}

const useStyles = makeStyles({
    root: {
        display: "flex",
        width: "100%",
        justifyContent: "end"    
    },
    button: {
        marginLeft: "1rem",
        padding: "0.5rem 1rem",
        color: "#737FA4",
        fontWeight: 400,
        fontSize: "0.9rem",
        "&:hover": {
            backgroundColor: "#F3F4F9"
        }
    },
    hideButton: {
        visibility: "hidden"
    }

})

const UserActions = ({
    hasPermission,
    handleEditUser,
    onDeleteUser
}: IUserActions) => {
    
    const classes = useStyles();
    const { t } = useTranslation();

    return (
        <div className={classes.root}>
            <Button className={classes.button} onClick={handleEditUser} >
                {
                    !hasPermission ? 
                        t("userManagement.list.viewPermissions") :
                        t("userManagement.list.editPermissions")
                } 
            </Button> 
            <Button className={`${classes.button} ${!hasPermission ? classes.hideButton : ""}`} onClick={onDeleteUser} disabled={!hasPermission}>
                <DeleteIcon htmlColor={'#c1cae1'} />
            </Button>
        </div>

    )
}

export default UserActions;